import {
  activeCss,
  backgroundCss,
  borderCss,
  boxShadowCss,
  buttonHoverCss,
  FontProps,
  fontCss,
  hoverTransformCss,
  hoverTransitionCss,
  lineHeightCss,
  mobileBackgroundCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileButtonHoverCss,
  mobileFontCss,
  mobileHoverTransformCss,
  mobileHoverTransitionCss,
  mobileLineHeightCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { ButtonUiInterface } from '../button-ui.schema'

interface ButtonUiProps
  extends FontProps,
    Pick<
      ButtonUiInterface,
      | 'alignSelf'
      | 'background'
      | 'backgroundColor'
      | 'border'
      | 'boxShadow'
      | 'hover'
      | 'active'
      | 'lineHeight'
      | 'mobileAlignSelf'
      | 'mobileBackground'
      | 'mobileBackgroundColor'
      | 'mobileBorder'
      | 'mobileBoxShadow'
      | 'mobileHover'
      | 'mobileLineHeight'
      | 'mobilePadding'
      | 'mobileWidth'
      | 'padding'
      | 'width'
    > {}

export const ButtonUi = styled.button<ButtonUiProps>`
  width: ${p => p.width || 'auto'};
  align-self: ${p => p.alignSelf || 'center'};
  opacity: ${p => (p.disabled ? '0.7' : '1')};
  cursor: pointer;
  border: none;
  ${backgroundCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${boxShadowCss}
  ${lineHeightCss}
  ${buttonHoverCss}
  ${hoverTransformCss}
  ${hoverTransitionCss}
  ${activeCss}

// wrapped in a condition so that there is no error in <EntityPreview /> in the sidebar
  ${p =>
    p?.theme?.phone &&
    css`
    ${p.theme.phone} {
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
      opacity: ${p.disabled ? '0.7' : '1'};
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileFontCss}
      ${mobileBorderCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      ${mobileButtonHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
    }
  `}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileButtonHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
    `}
`
